module.exports = __webpack_public_path__ + "img/MenuButton_NSW.182b9283.png";